// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"4bbf1903","246":"2bb52f6f","334":"a5264903","427":"2561bd57","428":"1890b82e","531":"37aa05a0","844":"347fc3bf"}[chunkId] + ".chunk.css";
};